// import http from '../../services/http'
import httpAuth from '../../services/httpAuth'

import getErrorMessage from '../../helpers/getErrorMessage.helper'
import { getSignUpSuccess, getSignUpError } from './signUp.slice'
import axios from 'axios'
import { BASE_DEV_URL } from '../../config/api.config'
import { getAffiliateCodeError, getAffiliateCodeSuccess } from './affiliate.slice'

// export const postNumberSignUp = (memberCode) => async (dispatch) => {
//   try {
//     const response = await http.get(`/account/${memberCode}/balance-settings`)
//     if (response.data.success) {
//       dispatch(getSignUpSuccess(response.data.result))
//     }
//     return response
//   } catch (e) {
//     dispatch(getSignUpError())
//     const errorMsg = getErrorMessage(e)
//     throw errorMsg
//   }
// }
// let token

export const postNumberSignUp = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('whatsapp/send-code', data)
    if (response.data.status) {
      // dispatch(getSignUpSuccess(response.data.success))
    }
    return response
  } catch (e) {
    dispatch(getSignUpError())
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const resendOTP = (data) => async (dispatch) => {
  //"orderId": ""
  try {
    const response = await httpAuth.post('whatsapp/re-send', data)
    if (response.data.status) {
      console.log(response.data)
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const resetWhatsAppPassword = (data, ip) => async (dispatch) => {
  //"orderId": ""
  try {
    const response = await httpAuth.post(`whatsapp/setPassword?ip=${ip}`, data)
    if (response.data.status) {
      console.log(response.data)
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const resetOtp = (data) => async (dispatch) => {
  //"orderId": ""
  try {
    const response = await httpAuth.post(
      '/whatsapp/resendResetPasswordOtp',
      data
    )
    if (response.data.status) {
      console.log(response.data)
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const verifyOTP = (data) => async (dispatch) => {
  // "orderId": "",
  // "otp":""
  try {
    const response = await httpAuth.post('whatsapp/verify', data)
    // const response = await axios.post( BASE_VERIFY_OTP_URL + '/auth/verifyOtp', data)
    if (response.data.status) {
      console.log(response.data)
      // token = response.headers.authorization
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

// export const registerNew = (data) => async (dispatch) => {
//   try {
//     const response = await httpAuth.post('/user/register', data)
//     // const response = await axios.post( BASE_VERIFY_OTP_URL + '/auth/verifyOtp', data)
//     if (response.data.success) {
//       console.log(response.data.success)
//       console.log(response)
//       // token = response.headers.authorization
//     }
//     return response
//   } catch (e) {
//     const errorMsg = getErrorMessage(e)
//     throw errorMsg
//   }
// }
export const registerNew = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/user/registerShoutpe', data)
    // const response = await axios.post( BASE_VERIFY_OTP_URL + '/auth/verifyOtp', data)
    if (response.data.success) {
      console.log(response.data.success)
      console.log(response)
      // token = response.headers.authorization
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const postCheckPromo = (memberCode, token, data) => async (dispatch) => {
  // const memberCode = getState().user.memberCode;
  console.log('token in req', token)
  try {
    const response = await axios.post(
      BASE_DEV_URL + `/account/${memberCode}/promotions/promo-code`,
      data,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    )
    if (response.data.success) {
      console.log(response.data.success)
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const getPromotionsList = () => async (dispatch) => {
  try {
    const response = await httpAuth.get('/promotions')
    if (response.data.success) {
      dispatch(getSignUpSuccess(response.data.result))
      console.log(response.data.success)
      // if(response?.data?.result.length){
      // }
    }
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const registerAffiliate = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/user/registerAffiliateUser', data)
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
export const getAffUserCount = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getAffUserCount', data)
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const getLast5AffComm = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getLast5AffComm', data)
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const getAffUserTodayPL = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getAffUserTodayPL', data)
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
export const getAffUsersList = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getAffUsersList', data)
    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const getUserAffCode = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getUserAffCode', data)

    if (response.data.status) {
      dispatch(getAffiliateCodeSuccess(response.data.data))
    }

    return response
  } catch (e) {
    dispatch(getAffiliateCodeError())
  }
}

export const getTop5LossUsers = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getTop5LossUsers', data)

    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
export const getAffUserSportWisePL = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getAffUserSportWisePL', data)

    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
export const getAffUserCreatedCountDateWise = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post(
      '/report/getAffUserCreatedCountDateWise',
      data
    )

    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
export const getMyAffComm = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getMyAffComm', data)

    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const getAffSpecificUserSportWisePL = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post(
      '/report/getAffSpecificUserSportWisePL',
      data
    )

    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
export const getAffBonusSetting = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post('/report/getAffBonusSetting', data)

    return response
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}
